import type { CognitiveDomain, EdicaoAdmin, EditionKind } from '../../services/admin';

/** Áreas da Academia da Mente, na ordem de exibição. */
export const DOMAINS: readonly { value: CognitiveDomain; label: string; color: string }[] = [
  { value: 'SPEED', label: 'Velocidade', color: '#4f9aa3' },
  { value: 'MEMORY', label: 'Memória', color: '#5aa84f' },
  { value: 'REASONING', label: 'Raciocínio', color: '#e85a68' },
  { value: 'LANGUAGE', label: 'Linguagem', color: '#f0a020' },
];

export const ACADEMY_POINTS_MIN = 1;
export const ACADEMY_POINTS_MAX = 50;

export const EDITION_KIND_LABEL: Record<EditionKind, string> = {
  DEFAULT: 'Edição comum',
  MIND_TRAINING: 'Treinamento (Academia da Mente)',
};

export const domainLabel = (d: CognitiveDomain): string =>
  DOMAINS.find((x) => x.value === d)?.label ?? d;

export const domainColor = (d: CognitiveDomain): string =>
  DOMAINS.find((x) => x.value === d)?.color ?? '#999999';

/** API antiga não manda `kind`: ausente conta como edição comum. */
export const editionKindOf = (e: { kind?: EditionKind | null } | undefined): EditionKind =>
  e?.kind ?? 'DEFAULT';

export const isTrainingEdicao = (edicoes: EdicaoAdmin[], id: number | undefined): boolean =>
  id !== undefined && editionKindOf(edicoes.find((e) => e.id === id)) === 'MIND_TRAINING';

/**
 * Campos da Academia no corpo do update. Fora de edição de Treinamento devolve `{}`:
 * os valores gravados ficam como estão (mover um jogo de edição por engano não apaga dados).
 */
export function academyPayload(
  visible: boolean,
  v: { cognitiveDomain?: CognitiveDomain; academyPoints?: number },
): { cognitiveDomain?: CognitiveDomain; academyPoints?: number } {
  if (!visible) return {};
  return { cognitiveDomain: v.cognitiveDomain, academyPoints: v.academyPoints };
}
